// src/contexts/useContentViewStore.js

import { create } from 'zustand';

const useContentViewStore = create((set) => ({
  currentView: 'Explore', // Default to Explore
  setView: (view) => set({ currentView: view }),
}));

export default useContentViewStore;
